export default __webpack_public_path__ + "static/media/406.7161b617.gif";